import { Box, BoxProps, Text, TextProps } from "@chakra-ui/react";
import { ReactNode, forwardRef } from "react";

interface ErrorMessageLabelProps {
  children: ReactNode;
  errorMessage?: string;
  messageErrorProps?: TextProps;
  containerProps?: BoxProps;
}

export const ErrorMessageLabel = forwardRef<
  HTMLDivElement,
  ErrorMessageLabelProps
>(({ children, errorMessage, messageErrorProps, containerProps }, ref) => {
  return (
    <Box pos="relative" role="group" {...containerProps}>
      {children}

      {errorMessage && (
        <Box
          ref={ref}
          bg="secondary.700"
          minW="26px"
          maxW="80%"
          pos="absolute"
          borderRadius="10px"
          p="3px"
          right={0}
          top="25px"
          zIndex="10"
          border="1px solid var(--chakra-colors-secondary-400)"
          transition="0.2s"
          transform="scale(0.8)"
          visibility="hidden"
          opacity={0}
          _groupHover={{
            transform: "scale(1)",
            visibility: "visible",
            opacity: "1"
          }}
        >
          <Box
            w="10px"
            h="10px"
            zIndex="-1"
            transform="rotate(45deg)"
            top="-6px"
            bg="secondary.700"
            right="10px"
            pos="absolute"
            borderTop="1px solid var(--chakra-colors-secondary-400)"
            borderLeft="1px solid var(--chakra-colors-secondary-400)"
            borderRadius="0 0 10px 0"
          />
          <Text
            color="#fff"
            fontWeight="bold"
            fontSize="9"
            whiteSpace="pre-wrap"
            {...messageErrorProps}
          >
            {errorMessage}&nbsp;
          </Text>
        </Box>
      )}
    </Box>
  );
});

ErrorMessageLabel.displayName = "ErrorMessageLabel";
